import { components } from 'react-select'
import React from 'react'
import { ReactComponent as DropdownArrow } from '../../../assets/icons/dropdown-arrow.svg'

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <DropdownArrow />
    </components.DropdownIndicator>
  )
}

export default DropdownIndicator
